import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { X } from "lucide-react";

const inputCls =
  "focus-visible:ring-2 focus-visible:ring-[#F97316]/30 focus-visible:border-[#F97316]";

// One customer's reference details block (name/email/phone/address + assigned sales agent).
export const CustomerCard = ({ customer, idx, agents, upd, onRemove }) => (
  <div
    className={`mt-3 ${idx > 0 ? "rounded-md border border-border p-3" : ""}`}
    data-testid={`customer-block-${idx}`}
  >
    <div className="flex items-center justify-between">
      <span className="text-[10px] font-bold uppercase tracking-wide text-[#F97316]">
        Customer {idx + 1}
      </span>
      {onRemove && (
        <Button
          variant="ghost"
          size="icon"
          className="h-6 w-6 text-[#57534E] hover:text-red-600"
          onClick={onRemove}
          data-testid={`remove-customer-${idx}`}
        >
          <X className="h-3.5 w-3.5" />
        </Button>
      )}
    </div>
    <div className="mt-1.5 grid grid-cols-1 md:grid-cols-3 gap-3">
      <div>
        <Label className="text-[10px] font-bold uppercase text-[#57534E]">Name</Label>
        <Input
          className={`mt-1 ${inputCls}`}
          placeholder="Customer name"
          value={customer.name}
          onChange={(e) => upd("name", e.target.value)}
          data-testid={idx === 0 ? "customer-name-input" : `customer-name-input-${idx}`}
        />
      </div>
      <div>
        <Label className="text-[10px] font-bold uppercase text-[#57534E]">Email</Label>
        <Input
          type="email"
          className={`mt-1 ${inputCls}`}
          placeholder="customer@example.com"
          value={customer.email}
          onChange={(e) => upd("email", e.target.value)}
          data-testid={idx === 0 ? "customer-email-input" : `customer-email-input-${idx}`}
        />
      </div>
      <div>
        <Label className="text-[10px] font-bold uppercase text-[#57534E]">Phone</Label>
        <Input
          type="tel"
          className={`mt-1 ${inputCls}`}
          placeholder="(555) 555-5555"
          value={customer.phone}
          onChange={(e) => upd("phone", e.target.value)}
          data-testid={idx === 0 ? "customer-phone-input" : `customer-phone-input-${idx}`}
        />
      </div>
      <div className="md:col-span-3">
        <Label className="text-[10px] font-bold uppercase text-[#57534E]">Address</Label>
        <Input
          className={`mt-1 ${inputCls}`}
          placeholder="Street, City, State ZIP"
          value={customer.address}
          onChange={(e) => upd("address", e.target.value)}
          data-testid={idx === 0 ? "customer-address-input" : `customer-address-input-${idx}`}
        />
      </div>
      <div className="md:col-span-3">
        <Label className="text-[10px] font-bold uppercase text-[#57534E]">Sales Agent (for this customer)</Label>
        <Select
          value={customer.agent?.email || ""}
          onValueChange={(v) => {
            const a = agents.find((x) => x.email === v);
            upd("agent", a ? { name: a.name, email: a.email } : null);
          }}
        >
          <SelectTrigger className={`mt-1 ${inputCls}`} data-testid={`customer-agent-select-${idx}`}>
            <SelectValue placeholder="Select agent…" />
          </SelectTrigger>
          <SelectContent>
            {agents.map((a) => (
              <SelectItem key={a.id} value={a.email}>
                {a.name} — {a.email}
              </SelectItem>
            ))}
            {customer.agent?.email && !agents.some((a) => a.email === customer.agent.email) && (
              <SelectItem value={customer.agent.email}>
                {customer.agent.name || customer.agent.email}
              </SelectItem>
            )}
          </SelectContent>
        </Select>
        {customer.agent?.email && (
          <p className="text-[11px] text-[#57534E] mt-1">
            CC on quotes: <span className="font-medium text-[#1C1917]">{customer.agent.email}</span>
          </p>
        )}
      </div>
    </div>
  </div>
);
